import React, { useEffect, useState } from "react";
import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded";
import { DeleteIcon, DeleteModal } from "../../comman/action/DeleteIcon";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import RestoreRoundedIcon from "@mui/icons-material/RestoreRounded";
import { dateFormat, dateTime, formatDateTime } from "../../components/Form";
import { SecondaryButton } from "../../components/Button/Button";
import {
  catchMessage,
  elseMessage,
  successMessage,
} from "../../comman/Message";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { useSearchParams } from "react-router-dom";
import useDebounce from "../../hooks/useDebounce";
import {
  deleteNotificationApi,
  deleteNotificationApis,
  getNotificationApi,
} from "../../services/notification";
import FloatingButton from "../../components/Button/FloatingButton";
import AddIcon from "@mui/icons-material/Add";
import AddNotification from "./AddNotificition";
import { PaginationShow } from "../../comman/action/Pagination";
const Notification = ({ type }) => {
  const [searchParam, setSearchParam] = useSearchParams();
  let activePage = +searchParam.get("page") || 1;
  const [search, setSearch] = useState(searchParam.get("query") || "");
  const debounceValue = useDebounce(search || "", 300);
  const [total, setTotal] = useState(0);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [notificationList, setNotificationList] = useState([]);
  const [schedulerList, setSchedulerList] = useState([]);
  const [aadModals, setAddModalShow] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModals, setDeleteModals] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [title, setTitle] = useState("");

  //*********Handel delete********* */
  const deleteHandler = (id, title) => {
    setDeleteModal(true);
    setDeleteId(id);
    setTitle(title);
  };
  const deleteHandlers = (id, title) => {
    setDeleteModals(true);
    setDeleteId(id);
    setTitle(title);
  };

  //*********Handel Pagination********* */njbfh
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };
  //-----------search-handler----------------
  const searchHandler = (e) => {
    setSearch(e.target.value);
    searchParam.set("page", 1);
    setSearchParam(searchParam);
  };
  //--------------delete-Notification------------------
  const deleteNotification = async () => {
    try {
      const res = await deleteNotificationApi(deleteId);
      if (res?.data?.status === 200) {
        successMessage(res);
        setDeleteModal(false);
        getNotification();
      } else {
        elseMessage(res);
      }
    } catch (err) {
      catchMessage(err);
    }
  };
  const deleteNotifications = async () => {
    try {
      const res = await deleteNotificationApis(deleteId);
      if (res?.data?.status === 200) {
        successMessage(res);
        setDeleteModals(false);
        getNotification();
      } else {
        elseMessage(res);
      }
    } catch (err) {
      catchMessage(err);
    }
  };
  //------------------listing-Api----------------------------------
  const getNotification = async (
    page = activePage,
    isSchedule = type === "1" ? false : true,
    search = debounceValue
  ) => {
    try {
      setNotificationList([]);
      setSchedulerList([]);
      showLoader();
      const res = await getNotificationApi({ page, isSchedule, search });
      if (res?.data?.status === 200) {
        setNotificationList(res?.data?.data?.list || []);
        setTotal(res?.data?.data?.total || 0);
        hideLoader();
      } else {
        setNotificationList([]);
        setSchedulerList([]);
        setTotal(0);
        hideLoader();
      }
    } catch (e) {
      hideLoader();
      catchMessage(e);
    }
  };

  useEffect(() => {
    if (debounceValue) {
      searchParam.set("query", debounceValue);
    } else {
      searchParam.delete("query");
    }
    if (activePage === 1) {
      searchParam.delete("page");
    }
    setSearchParam(searchParam);
    getNotification(activePage, type === "1" ? false : true, debounceValue);
  }, [searchParam, debounceValue, type, activePage]);

  useEffect(() => {
    if (type) {
      // searchParam.set("page", '');
      searchParam.delete("page");
      setSearch("");
    }
    setSearchParam(searchParam);
  }, [type]);

  return (
    <>
      {loader}
      <div className="FilterBox FilterArea">
        <div className="form-group search">
          <input
            type="search"
            className="form-control "
            placeholder="Search"
            value={search || ""}
            onChange={searchHandler}
          />
        </div>
      </div>

      {type === "1" ? (
        notificationList.length > 0 ? (
          notificationList.map(
            (
              { _id, createdAt, message, scheduleDateTime, title, userType },
              index
            ) => {
              return (
                <div key={index} className="row notify_list">
                  <div className="col-sm-9">
                    <h5>{userType}</h5>
                    <p>
                      <b className="d-block mb-1">{title}</b>
                      {message}
                    </p>
                  </div>
                  <div className="col-sm-3 text-end d-flex flex-column justify-content-between">
                    {/* <p><RestoreRoundedIcon /> 2 hours ago</p> */}
                    <p>
                      <RestoreRoundedIcon /> {dateTime(createdAt)}
                    </p>
                    <p>
                      <DeleteIcon onClick={() => deleteHandlers(_id)} />
                    </p>
                  </div>
                </div>
              );
            }
          )
        ) : (
          <>
            {/* if no notification then show */}
            <div className="row notify_list">
              <div className="col-sm-12">
                <h5 className="text-center mt-2">
                  No Notification Found <br />{" "}
                  <NotificationsNoneRoundedIcon sx={{ fontSize: 48 }} />
                </h5>
              </div>
            </div>
          </>
        )
      ) : notificationList.length > 0 ? (
        notificationList.map(
          (
            {
              _id,
              createdAt,
              message,
              scheduleDate,
              scheduleTime,
              title,
              userType,
            },
            index
          ) => {
            return (
              <div key={index} className="row notify_list">
                <div className="col-sm-9">
                  <h5>{userType}</h5>
                  <p>
                    <b className="d-block mb-1">{title}</b>
                    {message}
                  </p>
                </div>
                <div className="col-sm-3 text-end d-flex flex-column justify-content-between">
                  <p>
                    {/* <RestoreRoundedIcon /> {dateTime(scheduleDate)} */}
                    <RestoreRoundedIcon />{" "}
                    {formatDateTime(scheduleDate, scheduleTime)}
                    {/* {scheduleTime} */}
                  </p>
                  <p>
                    <DeleteIcon onClick={() => deleteHandler(_id, title)} />
                  </p>
                </div>
              </div>
            );
          }
        )
      ) : (
        <>
          {/* if no notification then show */}
          <div className="row notify_list">
            <div className="col-sm-12">
              <h5 className="text-center mt-2">
                No Notification Found <br />{" "}
                <NotificationsNoneRoundedIcon sx={{ fontSize: 48 }} />
              </h5>
            </div>
          </div>
        </>
      )}

      <FloatingButton
        onClick={() => setAddModalShow(true)}
        icon={<AddIcon />}
      />

      <PaginationShow
        activePage={activePage}
        total={total}
        handlePageChange={handlePageChange}
      />
      <AddNotification
        show={aadModals}
        close={() => setAddModalShow(false)}
        setAddModalShow={setAddModalShow}
        listing={getNotification}
      />

      <DeleteModal
        show={deleteModal}
        close={setDeleteModal}
        title="Cancel Notification"
        action={deleteNotification}
        name={title}
      />
      <DeleteModal
        show={deleteModals}
        close={setDeleteModals}
        title="Delete Notification"
        action={deleteNotifications}
        name={title}
      />
    </>
  );
};

export default Notification;
